import React from "react";
import { Dialog, FlatButton, DropDownMenu, MenuItem } from "material-ui";
import QuantityEditor from "./quantity-editor.jsx";
import Label from "./label.jsx";
import LinkLike from "./link-like.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../../stores/EventBucketStore";

class PrintPassesModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      skipCount: 0,
      labelType: "avery5360"
    };

    this._handleRequestClose = this._handleRequestClose.bind(this);
    this._handleRequestPrint = this._handleRequestPrint.bind(this);
    this._handleEdit = this._handleEdit.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    let state = EventBucketStore.getState();
    return state;
  }

  getStyles() {
    return {
      container: {
        margin: "15px 0"
      },
      inputContainer: {
        textAlign: "left",
        margin: "0 auto",
        maxWidth: "90%",
        width: 256
      },
      actions: {
        marginTop: 15
      },
      dialogTitle: {
        borderBottom: "none",
        paddingBottom: 0
      },
      dialogBody: {
        paddingBottom: 0
      },
      dialogActionsContainer: {
        borderTop: "none"
      }
    };
  }

  _handleRequestClose() {
    this.props.requestClose();
  }

  _handleRequestPrint(quick = true) {
    let { id } = this.props,
      { skipCount } = this.state,
      route = {
        pathname: `/event_buckets/${this.props.eventBucket}/pass_label_printer`,
        query: { quick: quick ? true : undefined, pass: id, skip: skipCount }
      };

    this.context.router.push(route);
  }

  _handleEdit() {
    this._handleRequestPrint(/* quick */ false);
  }

  render() {
    let styles = this.getStyles(),
      bucket = EventBucketStore.getEventBucketById(this.props.eventBucket),
      quantity = Array.isArray(this.props.id) ? this.props.id.length : 1;

    return (
      <Dialog
        title={"Quick print"}
        titleStyle={styles.dialogTitle}
        actionsContainerStyle={styles.dialogActionsContainer}
        bodyStyle={styles.dialogBody}
        openImmediately={true}
        actions={[
          <FlatButton label={"Cancel"} onTouchTap={this._handleRequestClose} />,
          <FlatButton
            label={"Print"}
            onTouchTap={this._handleRequestPrint}
            primary={true}
          />
        ]}
        autoScrollBodyContent={true}
        open={true}
        onRequestClose={this._handleRequestClose}
      >
        <div>
          <p>
            Ready to print {quantity} pass{quantity !== 1 ? "es" : ""} using
            your saved printing configuration{" "}
            <LinkLike onTouchTap={this._handleEdit}>(edit)</LinkLike>.
          </p>
          {bucket && bucket.label_printer_config.label_type === "sheet" ? (
            <div>
              <Label style={{ marginBottom: -10, marginTop: 20 }}>
                Number of labels to skip (to use a partially used sheet)
              </Label>
              <QuantityEditor
                style={{ marginLeft: -15 }}
                min={0}
                quantity={this.state.skipCount}
                updateQuantity={q => this.setState({ skipCount: q })}
              />
            </div>
          ) : null}
        </div>
      </Dialog>
    );
  }
}

export default connectToStores(PrintPassesModal);



// WEBPACK FOOTER //
// ./src/app/components/partials/print-passes-modal.jsx